import makeStyles from '@material-ui/core/styles/makeStyles';

const styles = makeStyles((theme) => ({
  filters: {
    margin: '16px 0 16px 0',
    background: 'white',
    padding: 16,
    borderRadius: 4,
    boxShadow: theme.shadows[1],
    width: '100%',

    '& form': {
      width: '100%',

      '& .--align-end': {
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
        paddingLeft: 12,

        '& button:last-child': {
          width: '100%',
          marginLeft: 24,
        },
      },
    },
  },
}));

export default styles;
